import { LOCATION_CHANGE } from 'connected-react-router';

import { FULFILL_SUBSCRIPTION, FULFILLMENT_FAILED, SUBSCRIPTION_FULFILLED } from '../actions/fulfillments/fulfill';
import {
  FULFILL_FLEX_DOWNSELL_SUBSCRIPTION,
  FLEX_DOWNSELL_FULFILLMENT_FAILED,
  FLEX_DOWNSELL_SUBSCRIPTION_FULFILLED,
} from '../actions/fulfillments/fulfillFlexDownsell';
import {
  DEACTIVATE_FULFILLMENT,
  FULFILLMENT_DEACTIVATED,
  DEACTIVATE_FULFILLMENT_FAILED,
} from '../actions/fulfillments/deactivate';
import { DOWNSELL_SUBSCRIPTION, DOWNSELL_FAILED, SUBSCRIPTION_DOWNSOLD } from '../actions/fulfillments/downsell';

const defaultState = {
  loading: false,
  newJourney: true,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case FULFILL_SUBSCRIPTION:
    case FULFILL_FLEX_DOWNSELL_SUBSCRIPTION:
    case DOWNSELL_SUBSCRIPTION:
    case DEACTIVATE_FULFILLMENT:
      return {
        ...state,
        loading: true,
      };
    case SUBSCRIPTION_FULFILLED:
    case FLEX_DOWNSELL_SUBSCRIPTION_FULFILLED:
    case SUBSCRIPTION_DOWNSOLD:
    case FULFILLMENT_DEACTIVATED:
      return {
        ...action.payload,
        loading: false,
        newJourney: false,
      };
    case FULFILLMENT_FAILED:
    case FLEX_DOWNSELL_FULFILLMENT_FAILED:
    case DOWNSELL_FAILED:
    case DEACTIVATE_FULFILLMENT_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case LOCATION_CHANGE:
      return {
        loading: false,
        newJourney: action.payload.location.pathname === '/switch',
      };
    default:
      return state;
  }
};
